<!-- SuccessAnimation.vue - Create this component if it doesn't exist -->
<template>
  <div v-if="visible" class="success-animation-overlay" @click="$emit('close')">
    <div class="success-animation-container" :class="{ 'animate-out': !visible }">
      <div class="success-checkmark">
        <div class="check-icon">
          <span class="icon-line line-tip"></span>
          <span class="icon-line line-long"></span>
          <div class="icon-circle"></div>
          <div class="icon-fix"></div>
        </div>
      </div>
      <h3 class="success-message">{{ message }}</h3>
      <div class="confetti-container">
        <div v-for="i in 50" :key="i" class="confetti" :style="getConfettiStyle(i)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessAnimation",
  props: {
    message: {
      type: String,
      default: "Success!"
    },
    duration: {
      type: Number,
      default: 2500
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    }
  },
  methods: {
    show() {
      this.visible = true;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.visible = false;
        this.$emit('close');
      }, this.duration);
    },
    getConfettiStyle(index) {
      const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7', '#dfe6e9', '#3b82f6', '#10b981', '#f59e0b', '#ef4444'];
      return {
        left: Math.random() * 100 + '%',
        animationDelay: (Math.random() * 2) + 's',
        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
        width: (Math.random() * 8 + 4) + 'px',
        height: (Math.random() * 8 + 4) + 'px',
        transform: `rotate(${Math.random() * 360}deg)`
      }
    }
  }
}
</script>

<style scoped>
.success-animation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.success-animation-container {
  background: white;
  padding: 40px 60px;
  border-radius: 20px;
  text-align: center;
  animation: slideUp 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.success-animation-container.animate-out {
  animation: fadeOut 0.3s ease forwards;
}

.success-checkmark {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
}

.check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid #4caf50;
}

.check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}

.check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotateCircle 4.25s ease-in;
}

.check-icon::before, .check-icon::after {
  content: '';
  height: 100px;
  position: absolute;
  background: #ffffff;
  transform: rotate(-45deg);
}

.icon-line {
  height: 5px;
  background-color: #4caf50;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}

.icon-line.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: iconLineTip 0.75s;
}

.icon-line.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: iconLineLong 0.75s;
}

.icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgba(76, 175, 80, 0.5);
}

.icon-fix {
  top: 8px;
  left: -26px;
  z-index: 1;
  width: 5px;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #ffffff;
}

@keyframes rotateCircle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}

@keyframes iconLineTip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes iconLineLong {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px) scale(0.8);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.success-message {
  color: #2c5aa0;
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0 0;
  animation: messagePulse 0.5s ease;
}

@keyframes messagePulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.confetti-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.confetti {
  position: absolute;
  top: -20px;
  width: 10px;
  height: 10px;
  background-color: #ff6b6b;
  opacity: 0.8;
  animation: confettiFall 3s linear forwards;
}

@keyframes confettiFall {
  0% {
    transform: translateY(-20px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(calc(100vh + 20px)) rotate(720deg);
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/importables/SuccessAnimation.vue